var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0C10.7333 0 8.30667 0.746669 6.26667 2.02667L15.4133 11.1867L15.4267 7.53336C15.4267 6.98669 15.88 6.53336 16.4267 6.53336C16.9867 6.53336 17.4267 6.98669 17.4267 7.53336L17.4133 13.6C17.4133 14.0134 17.16 14.3734 16.7867 14.5201C16.6667 14.5734 16.5333 14.6001 16.4133 14.6001C16.1467 14.6001 15.8933 14.4934 15.7067 14.3067L4.78667 3.37335C4.73333 3.32001 4.69333 3.26668 4.65333 3.21335C1.8 5.66669 0 9.29337 0 13.3334C0 20.6934 5.97333 26.6668 13.3333 26.6668C15.9333 26.6668 18.36 25.9201 20.4 24.6401L11.2533 15.4801L11.24 19.1334C11.24 19.6801 10.7867 20.1334 10.24 20.1334C9.68 20.1334 9.24 19.6801 9.24 19.1334L9.25333 13.0667C9.25333 12.6534 9.50667 12.2934 9.88 12.1467C10.24 11.9867 10.68 12.0667 10.96 12.36L21.88 23.2934C21.9333 23.3468 21.9733 23.4001 22.0133 23.4534C24.8667 21.0001 26.6667 17.3734 26.6667 13.3334C26.6667 5.97336 20.6933 0 13.3333 0Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0C10.7333 0 8.30667 0.746669 6.26667 2.02667L15.4133 11.1867L15.4267 7.53336C15.4267 6.98669 15.88 6.53336 16.4267 6.53336C16.9867 6.53336 17.4267 6.98669 17.4267 7.53336L17.4133 13.6C17.4133 14.0134 17.16 14.3734 16.7867 14.5201C16.6667 14.5734 16.5333 14.6001 16.4133 14.6001C16.1467 14.6001 15.8933 14.4934 15.7067 14.3067L4.78667 3.37335C4.73333 3.32001 4.69333 3.26668 4.65333 3.21335C1.8 5.66669 0 9.29337 0 13.3334C0 20.6934 5.97333 26.6668 13.3333 26.6668C15.9333 26.6668 18.36 25.9201 20.4 24.6401L11.2533 15.4801L11.24 19.1334C11.24 19.6801 10.7867 20.1334 10.24 20.1334C9.68 20.1334 9.24 19.6801 9.24 19.1334L9.25333 13.0667C9.25333 12.6534 9.50667 12.2934 9.88 12.1467C10.24 11.9867 10.68 12.0667 10.96 12.36L21.88 23.2934C21.9333 23.3468 21.9733 23.4001 22.0133 23.4534C24.8667 21.0001 26.6667 17.3734 26.6667 13.3334C26.6667 5.97336 20.6933 0 13.3333 0Z",
    fill: "url(#paint0_linear_3809_28174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3809_28174",
    x1: 0,
    y1: 0,
    x2: 26.6668,
    y2: 26.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertIcon);
export default __webpack_public_path__ + "static/media/convertIcon.4b7c7d183547cb4d267f532384bd976d.svg";
export { ForwardRef as ReactComponent };